<template>
  <b-col class="my-1">
    <div class="custom-border-card-305 ">
      <div class="card-image-section mt-2 position-relative">
        <img :src="product.thumbnail" class="col-lg-12 product-image" :alt="product.name">
      </div>
      <div class="card-product-section mt-2 col-lg-11 text-center">
        <m-a class="text-white text-decoration-none"
             :href="{name:'Product',params: { name: product.raw_link }}">
          <p class="product-name " v-b-tooltip.hover :title="product.name">{{ product.name }}</p>
        </m-a>

        <m-product-price-100 class="text-white" :product="product"/>

        <m-shopping-cart-controller-1 id="product-305-shopping-card-controller" :product="product"/>

      </div>
    </div>

  </b-col>
</template>

<script>
export default {
  name: "productCard",
  props: {
    product: {}
  }
}
</script>

<style scoped>

.product-name {
  font-size: 16px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  cursor: pointer;
}

.card-image-section {
  height: 240px;
}

.product-image {
  object-fit: contain;
  height: 100%;
}

.price-font-size {
  font-size: 19px;
}

.price-color {
  color: var(--secondary);
}

.card-image-section {
  position: relative;
}

#product-305-shopping-card-controller {
  bottom: 0;
}

.offer {
  top: 0;
  left: 0;
  background: var(--primary);
  padding: 3px;
  border-radius: 4px;
  position: absolute;
}
</style>